// current value format version
export const version = 1;
